export const engagementModelContentArabic = {
  heading: "مرنة لدينا",
  darkHeading: "نماذج المشاركة",
  subheading:
    "اختر نموذج التعاقد الذي يناسب احتياجات مشروعك! سواء كنت بحاجة إلى مطورين بدوام كامل، جزئي، أو بالساعة، فإننا نقدم خيارات مرنة لضمان تعاون سلس وكفاءة قصوى طوال فترة مشروعك.",
  models: [
    {
      index: "1.",
      title: "تعزيز الفريق",
      description:
        "أضف محترفين مهرة إلى فريقك لسد فجوات المهارات وزيادة الموارد عند الحاجة.",
      icon: "/images/engagement-model-gifs/hourly-icon.svg",
      iconWidth: 40,
    },
    {
      index: "2.",
      title: "الفرق المخصصة",
      description:
        "فريق عمل بدوام كامل مكرس فقط لمشروعك، مما يضمن التوافق التام مع أهدافك.",
      icon: "/images/engagement-model-gifs/price-icon.svg",
      iconWidth: 35,
    },
    {
      index: "3.",
      title: "حلول المشاريع الجاهزة",
      description:
        "مثالية للمشاريع المحددة ذات الجداول الزمنية الواضحة. دعنا نتولى كل شيء من البداية حتى النهاية.",
      icon: "/images/engagement-model-gifs/retainer-icon.svg",
      iconWidth: 40,
    },
  ],
  cta: {
    text: "احصل على حلك المخصص",
    button: "تواصل معنا",
    link: "/contact-us",
  },
};
